import React from 'react';
import PropTypes from 'prop-types';
import CwTextField from '../cwtextfield/CwTextField';
import CwLabel from '../cwlabel/CwLabel';
import css from './CwFilterList.scss';

class CwFilterList extends React.Component {
  constructor(props) {
    super(props);

    let {defaultFilter, options} = this.props;
    this.state = {
      // Filter text
      filter: defaultFilter,
      // Options which haven't been selected and match the filter text
      filteredOptions: this.filterOptions(defaultFilter, options),
      // Values of <options> currently selected in the <select>
      selectedValues: []
    };
  }

  makeLookup(arr, prop) {
    if(!arr) {
      return {};
    }

    let lkup = {};
    for (let i = 0, l = arr.length; i < l; i++) {
      if (prop) {
        lkup[arr[i][prop]] = true;
      }
      else {
        lkup[arr[i]] = true;
      }
    }
    return lkup;
  }

  getItemsByProp(arr, prop, values) {
    let items = [];
    let found = 0;
    let valuesLookup = this.makeLookup(values);
    for (let i = 0, la = arr.length, lv = values.length;
        i < la && found < lv;
        i++) {
      let key = (typeof prop === undefined) ? arr[i].id : arr[i][prop];
      if (valuesLookup[key]) {
        items.push(arr[i]);
        found++;
      }
    }
    return items;
  }

  componentDidMount() {
    // NOTE: Perform any magic you need when the filterlist re-mounts (i.e. after pod collapses then re-expands)
    if (this.props.onLoad) {
      this.props.onLoad();
    }    
  }

  componentWillReceiveProps(nextProps) {

    // Update visibile options in response to options or value
    // changing. Also update selected values after the re-render completes, as
    // one of the previously selected options may have been removed.
    if (nextProps.options !== this.props.options ||
        nextProps.value !== this.props.value ||
        nextProps.options.length !== this.props.options.length ||
        nextProps.value.length !== this.props.value.length) {
      this.setState({
        filteredOptions: this.filterOptions(this.state.filter,
                                             nextProps.value,
                                             nextProps.options)
      }, this.updateSelectedValues);
    }
  }

  focus() {
    this.select.focus();
  }

  /**
   * Filters the visible array of options in the list based on
   * the filter.
   */
  filterOptions = (filter, selectedOptions, options) => {
    if (typeof filter == 'undefined') {
      filter = this.state.filter;
    }

    if (typeof selectedOptions == 'undefined') {
      selectedOptions = this.props.value;
    }

    if (typeof options == 'undefined') {
      options = this.props.options;
    }

    filter = filter.toUpperCase();

    let {mapKey} = this.props;
    let selectedValueLookup = this.makeLookup(selectedOptions, mapKey);
    let filteredOptions = [];
    let optLength = (typeof options == 'undefined') ? 0 : options.length;

    for (let i = 0, l = optLength; i < l; i++) {
      if (!selectedValueLookup[options[i].name] &&
          (!filter || options[i].name.toUpperCase().indexOf(filter) !== -1)) {
        filteredOptions.push(options[i]);
      }
    }

    return filteredOptions;
  }

  /**
   * Update the filter and filter options and filter the list
   */
  onFilterChange = (event) => {
    let filter = event;
    this.setState({
      filter,
      filteredOptions: this.filterOptions(filter)
    }, this.updateSelectedValues);
  }

  /**
   * On 'Enter' key event clear out the state for filter and selectedValues
   * and fire off the onChange event for our selectedOptions.
   */
  onFilterKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.state.filteredOptions.length === 1) {
        let selectedOption = this.state.filteredOptions[0];
        let selectedOptions = this.props.value.concat([selectedOption]);
        this.setState({filter: '', selectedValues: []}, () => {
          this.props.onChange(selectedOptions);
        });
      }
    }
  }

  /**
   * Update the selectedValues of the state based on what is
   * selected in the list
   */
  updateSelectedValues = (event) => {
    let selection = event ? event.target : this.select;
    let selectedValues = [];
    for (let i = 0, l = selection.options.length; i < l; i++) {
      if (selection.options[i].selected) {
        selectedValues.push(selection.options[i].value);
      }
    }

    // Always update if we were handling an event, otherwise only update if
    // selectedValues has actually changed.
    if (event || String(this.state.selectedValues) !== String(selectedValues)) {
      this.setState({selectedValues:selectedValues});
      this.props.onChange(selectedValues);
    }
  }

  /**
   * Update the value (selected items) and clear out the states list
   * of selected because we already added it to the value.
   */
  addSelectedToSelection = () => {
    let selectedOptions =
      this.props.value.concat(this.getItemsByProp(this.state.filteredOptions,
                                                       this.props.mapKey,
                                                       this.state.selectedValues));
    this.setState({selectedValues: []}, () => {
      this.props.onChange(selectedOptions);
    });
  }
  /**
   * Handler for when the list loses focus
   */
  onBlur = () => {
    /*istanbul ignore else*/
    if(this.props.onBlur)
      this.props.onBlur();
  }
  /**
   * Handler for when the list receives focus
   */
  onFocus = () => {
    /*istanbul ignore else*/
    if(this.props.onFocus)
      this.props.onFocus();
  }

  render() {
    let {filter, filteredOptions, selectedValues} = this.state;
    let {cwId, disabled, placeholder, size, invalid, readOnly, includeFilter, listHeader} = this.props;

    return (
      <div data-cwid={cwId} className={css.wrap}>
        <CwLabel value={listHeader} className={css.header} />
        <select multiple={this.props.allowMultiSelect}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          className={this.props.invalid ? css.listInvalid : css.list}
          ref={(select) => this.select = select}
          size={size}
          value={selectedValues}
          onChange={this.updateSelectedValues}
          onDoubleClick={this.addSelectedToSelection}
          disabled={disabled}
          >
          {filteredOptions.map((option) => {
            return <option key={option.id} value={option.id}>{option.name}</option>;
          })}
        </select>
        {includeFilter ?
            <CwTextField
            className={this.props.invalid ? css.filterInvalid : css.filter}
            placeholder={placeholder}
            value={filter}
            invalid={invalid}
            readOnly={readOnly}
            disabled={disabled}
            onChange={this.onFilterChange}
            onKeyPress={this.onFilterKeyPress}
          /> : null
        } 
      </div>
    );
  }
}

CwFilterList.propTypes = {
  /**
   * Callback function that is fired when filterlist's selection changes
   */
  onChange: PropTypes.func,
  /**
   * Array of options to be listed in the dropdown menu. Must contain at least "id" and "name" fields.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  /**
   * Represents the item(s) that has been selected from the list.
   */
  value: PropTypes.arrayOf(PropTypes.number),
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Default text to display on filter
   */
  defaultFilter: PropTypes.string,
  /**
   * Number of records to display in the list before scroll
   */
  size: PropTypes.number,
  /**
   * Used to control if filterlist is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable filterlist
   */
  disabled: PropTypes.bool,
  /**
   * Used to set the inner text field to a read only mode
   */
  readOnly: PropTypes.bool,
  /**
   * Allows the user to select multiple items at the same time
   */
  allowMultiSelect: PropTypes.bool,
  /**
   * Place holder test for the filter box
   */
  placeholder: PropTypes.string,
  /**
   * Boolean to render the filter or not
   */
  includeFilter: PropTypes.bool,
  /**
   * Key for the filter map lookup used to filter the list by property
   */
  mapKey: PropTypes.string,
  /**
   * Header to display above the list box
   */
  listHeader: PropTypes.string,
  /**
   * focus handler
   */
  onFocus: PropTypes.func,
  /**
   * blur handler
   */
  onBlur: PropTypes.func
};

CwFilterList.defaultProps = {
  defaultFilter: '',
  size: 6,
  includeFilter: true,
  allowMultiSelect: true
};

export default CwFilterList;


// WEBPACK FOOTER //
// ./src/components/cwfilterlist/CwFilterList.jsx